import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { useIntl } from "react-intl";
import EditIcon from "@mui/icons-material/Edit";
import { messages } from "./UpdateMeetingParticipantsButton.messages";
import PermissionController from "../../PermissionController/PermissionController";
import { UserAuthorityType, UserRoleType } from "../../../generated/user-api";
import { Meeting } from "../../../Models/Meeting";
import ModifyMeetingParticipantsDialog from "../../Dialogs/ModifyMeetingParticipantsDialog/ModifyMeetingParticipantsDialog";

interface Props {
  meeting: Meeting;
  onChanged?: () => void;
}

const UpdateMeetingParticipantsButton = (props: Props) => {
  const { meeting, onChanged } = props;
  const intl = useIntl();
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const handleOpenDialog = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsDialogOpen(true);
  };

  return (
    <PermissionController
      allowedRoles={[UserRoleType.Staff]}
      atLeastOneOfAuthoritiesStaff={[
        UserAuthorityType.BookMeeting,
        UserAuthorityType.BookMeetingOther,
        UserAuthorityType.AdminSite,
      ]}
    >
      <ModifyMeetingParticipantsDialog
        isOpen={isDialogOpen}
        meeting={meeting}
        onClose={() => setIsDialogOpen(false)}
        onUpdated={onChanged}
      />
      <Button
        size="small"
        color="primary"
        variant="contained"
        startIcon={<EditIcon />}
        onClick={handleOpenDialog}
      >
        {intl.formatMessage(messages.buttonLabel)}
      </Button>
    </PermissionController>
  );
};

export default UpdateMeetingParticipantsButton;
